import { NgModule } from '@angular/core';
import { ReplaceIfNull } from './replaceIfNull.pipe';
import { LocalizedDatePipe } from './LocalizedDatePipe.pipe';
import { replaceIfEmptyString } from './replaceIfEmptyString.pipe';
import { FitlerArrayPipe } from './FitlerArrayPipe.pipe';
import { FirstNPipe } from './firstN.pipe';

@NgModule({
  declarations: [ReplaceIfNull, LocalizedDatePipe, replaceIfEmptyString, FitlerArrayPipe, FirstNPipe],
  exports: [ReplaceIfNull, LocalizedDatePipe, replaceIfEmptyString, FitlerArrayPipe, FirstNPipe],
})
export class PipeModule {}
